import {EmployeeCostDto} from "../../../../../models/employee-cost-dto";

export class EmploymentCostUtility {
  static employeeCostCalculationFn: (employeeCostDto: EmployeeCostDto) => number = (employeeCostDto: EmployeeCostDto) => (employeeCostDto.salary * employeeCostDto.workingHours) + employeeCostDto.salaryAdditions
  static employeeHoursCalculationFn: (employeeCostDto: EmployeeCostDto) => number = (employeeCostDto: EmployeeCostDto) => employeeCostDto.workingHours

  static sumEmploymentCost(employeeCosts: EmployeeCostDto[]): number {
    return employeeCosts.reduce((acc, employeeCost) => acc + this.employeeCostCalculationFn(employeeCost), 0)
  }

  static sumEmploymentHours(employeeCosts: EmployeeCostDto[]): number {
    return employeeCosts.reduce((acc, employeeCost) => acc + this.employeeHoursCalculationFn(employeeCost), 0);
  }

  static sumEmploymentCostByEachEvent(employmentCost: { [eventId: string]: EmployeeCostDto[] }): {
    [eventId: string]: number
  } {
    const employmentCostByEventId: { [eventId: string]: number } = {}
    for (let eventId in employmentCost) {
      employmentCostByEventId[eventId] = this.sumEmploymentCost(employmentCost[eventId])
    }
    return employmentCostByEventId
  }

  static sumEmploymentHoursByEvent(employmentCost: { [eventId: string]: EmployeeCostDto[] }): {
    [eventId: string]: number
  } {
    const employmentHoursByEventId: { [eventId: string]: number } = {}
    for (let eventId in employmentCost) {
      employmentHoursByEventId[eventId] = this.sumEmploymentHours(employmentCost[eventId])
    }
    return employmentHoursByEventId;
  }

  static sumTotalEmploymentCost(employmentCost: { [eventId: string]: EmployeeCostDto[] }): number {
    let totalEmploymentCost = 0
    for (let eventId in employmentCost) {
      totalEmploymentCost += this.sumEmploymentCost(employmentCost[eventId])
    }
    return totalEmploymentCost
  }


}
